/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Template_Topic_Drag_InstructionsInputs */



/**
* | output |
* | --- |
* | "Use the up and down arrows to move this topic." |
*
* @param {Settings_Template_Topic_Drag_InstructionsInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_template_topic_drag_instructions = /** @type {((inputs?: Settings_Template_Topic_Drag_InstructionsInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Template_Topic_Drag_InstructionsInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Gebruik de pijltjes omhoog en omlaag om dit onderwerp te verplaatsen.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Utilisez les flèches haut et bas pour déplacer ce sujet.")
	return /** @type {LocalizedString} */ ("Use the up and down arrows to move this topic.")
});